import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import {
  ADD_SPEAKERS_API_URL,
  DELETE_SPEAKERS_API_URL,
  GET_ALL_SPEAKERS_API_URL,
  REMOVE_UNUSED_SPEAKERS_API_URL,
  UPDATE_SPEAKERS_API_URL,
} from '../../../../constants/ApiUrlConstants';
import { getApiRequest, postApiRequest } from '../../../../features/axiosClient';
import {
  addSpeakersFailure,
  addSpeakersSuccess,
  deleteSpeakersFailure,
  deleteSpeakersSuccess,
  getAllSpeakersFailure,
  getAllSpeakersRequest,
  getAllSpeakersSuccess,
  removeUnusedSpeakersFailure,
  removeUnusedSpeakersSuccess,
  updateSpeakersFailure,
  updateSpeakersSuccess,
} from '../actions';

// get all speakers list
const getAllSpeakerAPI = (action) => getApiRequest(`${GET_ALL_SPEAKERS_API_URL}?AudioFileId=${action}`);

function* handleGetAllSpeaker(action) {
  try {
    const response = yield call(getAllSpeakerAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(getAllSpeakersSuccess(response));
  } catch (error) {
    yield put(getAllSpeakersFailure(error));
  }
}

export function* watchGetAllSpeaker() {
  yield takeLatest(types.GET_ALL_SPEAKERS_REQUEST, handleGetAllSpeaker);
}

//update project speaker
const updateSpeakerAPI = (action) =>
  postApiRequest(
    `${UPDATE_SPEAKERS_API_URL}?fileId=${action.fileId}&OldSpeakerName=${action.OldSpeakerName}&NewSpeakerName=${action.NewSpeakerName}`,
  );

function* handleUpdateSpeaker(action) {
  try {
    const { onUpdate, ...rest } = action.payload;
    const response = yield call(updateSpeakerAPI, rest);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(updateSpeakersSuccess(response));
    if (action.payload.fileId) yield put(getAllSpeakersRequest(rest.fileId));
    if (onUpdate) onUpdate();
  } catch (error) {
    yield put(updateSpeakersFailure(error));
  }
}

export function* watchUpdateSpeaker() {
  yield takeLatest(types.UPDATE_SPEAKERS_REQUEST, handleUpdateSpeaker);
}

// delete project speaker
const deleteSpeakerAPI = (action) =>
  postApiRequest(`${DELETE_SPEAKERS_API_URL}?fileId=${action.fileId}&speakerNames=${action.SpeakerNames}`);

function* handleDeleteSpeaker(action) {
  try {
    const response = yield call(deleteSpeakerAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(deleteSpeakersSuccess(response));
  } catch (error) {
    yield put(deleteSpeakersFailure(error));
  }
}

export function* watchDeleteSpeaker() {
  yield takeLatest(types.DELETE_SPEAKERS_REQUEST, handleDeleteSpeaker);
}

// add project speaker
const addSpeakerAPI = (action) =>
  postApiRequest(
    `${ADD_SPEAKERS_API_URL}?fileId=${action.fileId}&speakerName=${action.speakerName}&speakerNames=${action.speakerNames}`,
  );

function* handleAddSpeaker(action) {
  try {
    const response = yield call(addSpeakerAPI, action.payload);
    if (action.payload.fileId) yield put(getAllSpeakersRequest(action.payload.fileId));

    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(addSpeakersSuccess(response));
  } catch (error) {
    yield put(addSpeakersFailure(error));
  }
}

export function* watchAddSpeaker() {
  yield takeLatest(types.ADD_SPEAKERS_REQUEST, handleAddSpeaker);
}

// remove unused project speaker
const removeUnusedSpeakerAPI = (action) =>
  postApiRequest(
    `${REMOVE_UNUSED_SPEAKERS_API_URL}?projectId=${action.fileId}&fileId=${action.fileId}&SpeakerNames=${action.SpeakerNames}`,
  );

function* handleRemoveUnusedSpeaker(action) {
  try {
    const response = yield call(removeUnusedSpeakerAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(removeUnusedSpeakersSuccess(response));
  } catch (error) {
    yield put(removeUnusedSpeakersFailure(error));
  }
}

export function* watchRemoveUnusedSpeaker() {
  yield takeLatest(types.REMOVE_UNUSED_SPEAKERS_REQUEST, handleRemoveUnusedSpeaker);
}
